import { Component } from '@angular/core';
import { CompaniesService, CompanySummary } from 'src/app/core/companies.service';
import { ErrorService } from 'src/app/core/error.service';

@Component({
  selector: 'app-companies-summary',
  templateUrl: './companies-summary.component.html',
  styleUrls: ['./companies-summary.component.scss'],
})
export class CompaniesSummaryComponent {
  is_summary_request_running: boolean = true;
  summary?: CompanySummary;

  constructor(private error_service: ErrorService, private companies_service: CompaniesService) {}

  ngOnInit(): void {
    this.readSummary();
  }

  onRefresh(): void {
    this.readSummary();
  }

  readSummary(): void {
    this.is_summary_request_running = true;
    this.companies_service.readSummary().subscribe({
      next: response => {
        this.summary = response.data;
        this.is_summary_request_running = false;
      },
      error: error => {
        this.error_service.processGenericApiError(error);
        this.is_summary_request_running = false;
      },
    });
  }
}
